<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Bulk Status Update</strong>
            <div class="card-header-actions">
              <b-button :disabled="isReadOnly"
                class="btn btn-sm btn-primary mr-4 btn-pill"
                :pressed.sync="myToggle"
                v-on:click="uploadcsv()"
                variant="primary"
                type="button"
                >Upload CSV</b-button
              >

              <button
                class="btn btn-sm btn-primary ml-4"
                v-on:click="refresh()"
                type="button"
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>

          <div
            v-if="addzone"
            style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);"
            class="mb-1"
          >
            <b-form
              @submit.prevent="validateForm('form-1')"
              data-vv-scope="form-1"
            >
              <b-row md="12">
                <b-col md="4">
                  <b-form-group>
                    <b-row>
                      <b-col md="3">
                        <label><b>Action</b></label>&nbsp;<span style="color: red;">*</span>
                      </b-col>
                      <b-col md="9">
                        <b-form-select
                        v-model="selectedAction"
                        name="action"
                        v-validate="'required|'"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-1.action'),
                        }"
                      >
                        <option :value="selected">--Select Action--</option>
  
                        <option value="BookingDone">Booking Done</option>
                        <option value="PickDone">PickDone</option>
                        <option value="ZoneOutScan">ZoneOutScan</option>
                        <option value="DispatchOutScan">DispatchOutScan</option>

                        <option value="OFD">OFD</option>
                        <option value="Delivered">Delivered</option>
                        <option value="partialDLV">Partial Delivered</option>

                        
                        <option value="RTO">RTO</option>
                        <option value="RTO-DLV">RTO Delivered</option>
                         <option value="Lost">Lost</option>

                       <!-- <option value="RTOHubInScan">RTOHubInScan</option>
                        <option value="RTOZoneInScan">RTOZoneInScan</option>
                        <option value="RTOZoneOutScan">RTOZoneOutScan</option>
                        <option value="RTODispatchOutScan">RTODispatchOutScan</option>
                        <option value="RTOOFD">RTOOFD</option>
                        <option value="RTOINTransit">RTOINTransit</option>
                        <option value="RTOpartialDLV">Partial RTO-DLV</option>
                        <option value="RTOLost">RTOLost</option>  -->

                      </b-form-select>
                      <span
                        v-show="errors.has('form-1.action')"
                        class="help text-danger"
                        >{{ errors.first("form-1.action") }}</span
                      >
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="selectedAction != ''">
                  <b-form-group>
                    <b-row>
                      <b-col md="4">
                        <label><b>Upload CSV File</b></label>&nbsp;<span style="color: red;">*</span>
                      </b-col>
                      <b-col md="8">
                        <b-form-file
                      type="file"
                      v-model="file"
                      :state="Boolean(file)"
                      @change="selectcsvFiletoUpload($event)"
                      placeholder="Upload CSV File"
                      accept=".csv"
                      required
                      v-validate="'required|'"
                      :class="{
                        file: true,
                        'is-invalid': errors.has('form-1.file'),
                      }"
                    ></b-form-file>
                    <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i
                          class="fa fa-warning"
                          v-show="errors.has('file')"
                        ></i>
                      </span>
                      <code
                        v-show="errors.has('form-1.file')"
                        id="addmblnbrmsg"
                        class="help text-danger"
                        >{{ errors.first("form-1.file") }}
                      </code>
                    </b-input-group>
                    <div>
                      <label for="name" v-if="selectedAction == 'BookingDone'"
                      ><a
                        href="img/SampleBookingDoneCSV.csv"
                        download="SampleForBookingDone.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>

                    <label for="name" v-if="selectedAction == 'Delivered'"
                      ><a
                        href="img/SampleDelivered.csv"
                        download="SampleForDelivered.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>
                    <label for="name" v-if="selectedAction == 'Delivered'">
                      <span style="color:red"
                        >Note : Date Format must be DD-MM-YYYY OR DD/MM/YYYY</span
                      >
                    </label>
                    <label for="name" v-if="selectedAction == 'partialDLV'"
                      ><a
                        href="img/partialDeliveryNew.csv"
                        download="SampleForPartialDelivered.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>
                    <label for="name" v-if="selectedAction == 'partialDLV'">
                      <span style="color:red"
                        >Note : Date Format must be DD-MM-YYYY OR DD/MM/YYYY </span
                      >
                    </label>
                    <label
                      for="name"
                      v-if="selectedAction == 'PickDone'"
                      ><a
                        href="img/SamplePickDone.csv"
                        download="SamplePickDone.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>
                    <label
                      for="name"
                      v-if="selectedAction == 'RTO' || selectedAction == 'Lost'"
                      ><a
                        href="img/RTOCSV.csv"
                        :download="selectedAction == 'RTO'?'RTOCSV.csv':'LostCSV.csv'"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>
                     <label
                      for="name"
                      v-if="selectedAction == 'RTO-DLV' "
                      ><a
                        href="img/RTODLVCSV.csv"
                        :download="'RTODLVCSV.csv'"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>

                   
                    <label
                      for="name"
                      v-if="selectedAction == 'ZoneOutScan'"
                      ><a
                        href="img/SampleZoneOutScan.csv"
                        download="SampleZoneOutScan.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>
                    <label
                      for="name"
                      v-if="selectedAction == 'DispatchOutScan'"
                      ><a
                        href="img/SampleDispatchOutScan.csv"
                        download="SampleDispatchOutScan.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>
                    <label
                      for="name"
                      v-if="selectedAction == 'OFD'"
                      ><a
                        href="img/SampleOFD.csv"
                        download="SampleOFD.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    </label>
                     <label
                      for="name"
                      v-if="['RTOHubInScan','RTOZoneInScan','RTOZoneOutScan','RTODispatchOutScan','RTOOFD','RTOINTransit','RTOpartialDLV','RTOLost'].includes(selectedAction)">
                      <a
                        href="/img/SampleRtoUpdateStatus.csv"
                        download="SampleRtoUpdateStatus.csv"
                      >
                        Download Sample CSV
                      </a>
                    </label>

                    </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>

                <b-col md="4" v-if="selectedAction == 'RTO'">
                  <b-form-group>
                    <b-row>
                      <b-col md="3">
                        <label><b>Status</b></label>&nbsp;<span style="color: red;">*</span>
                      </b-col>
                      <b-col md="9">
                        <b-form-select
                        v-model="selectedStatus"
                        name="status"
                        v-validate="'required|'"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-1.status'),
                        }"
                      >
                        <option :value="selected">--Select Status--</option>
                          <option value="RTO">RTO</option>

                       <!-- <option value="RTO-eWayBill-EXP">RTO-eWayBill-EXP</option>
                        <option value="RTO-PKUP-CAN">RTO-PKUP-CAN</option>
                        <option value="RTO">RTO</option>
                        <option value="RTO-NC">RTO-NC</option>
                        <option value="RTO-SF">RTO-SF</option>
                        <option value="RTO-DLY-SHIPPING">RTO-DLY-SHIPPING</option>
                        <option value="IT-DMG">IT-DMG</option>-->
                      </b-form-select>
                      <span
                        v-show="errors.has('form-1.status')"
                        class="help text-danger"
                        >{{ errors.first("form-1.status") }}</span
                      >
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col md="5" v-if="selectedAction == 'RTO'">
                  <b-form-group>
                    <b-row>
                      <b-col md="3">
                        <label><b>Reason</b></label>&nbsp;<span style="color: red;">*</span>
                      </b-col>
                      <b-col md="8">
                        <b-form-select
                          v-model="selectedReason"
                          name="Reason"
                          v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.Reason'),
                          }"
                        >
                          <option :value="selected">--Select Reason--</option>
                          <option :value="reason.rto_statuscode"  v-for="reason in reasonList">{{reason.rto_reason}}</option> 
                        </b-form-select>
                        <span
                          v-show="errors.has('form-1.Reason')"
                          class="help text-danger"
                          >{{ errors.first("form-1.Reason") }}</span
                        >
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>

                <b-col sm="2" v-if="selectedAction != ''">
                  <b-button variant="primary" size="md" type="submit"
                    >Upload</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </div>
          <div
            id="showerror"
            style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;"
            class="mb-1"
          >
            <b-row>
              <b-col md="12" v-if="selectedAction == 'BookingDone'">
                <span>
                  <h6>
                    <b>Accepted Load : </b>

                    <!-- <br> -->
                    <strong
                      v-if="acceptedloads != ''"
                      v-for="accload in acceptedloads"
                      >{{ accload }}&nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6>
                    <b>Invalid Load in CSV : </b>
                    <!-- <br> -->
                    <strong
                      v-if="invalidload != ''"
                      style="color:#FF6347;"
                      v-for="invalidload in invalidload"
                      >{{ invalidload }}&nbsp;&nbsp;</strong
                    >
                  </h6>

                  <br />

                  <h6>
                    <b>Invalid VehicleNo in CSV : </b>
                    <!-- <br> -->
                    <strong
                      v-if="invalidvehicleno != ''"
                      style="color:#FF6347;"
                      v-for="invalidvehicleno in invalidvehicleno"
                      >{{ invalidvehicleno }} &nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6>
                    <b>Loads Already Assigned in CSV : </b>

                    <strong
                      v-if="otherstatusload != ''"
                      style="color:#FF6347;"
                      v-for="otherstatusload in otherstatusload"
                      >{{ otherstatusload }} &nbsp;&nbsp;
                    </strong>
                  </h6>
                </span>
              </b-col>
              <b-col md="12" v-if="selectedAction == 'Delivered'">
                <span>
                  <h6>
                    <b>Delivered Load : </b>

                    <!-- <br> -->
                    <strong
                      v-if="deliveredload != ''"
                      v-for="divload in deliveredload"
                      >{{ divload }}&nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6>
                    <b>Invalid Load in CSV : </b>
                    <!-- <br> -->
                    <strong
                      v-if="invaliddeliveredload != ''"
                      style="color:#FF6347;"
                      v-for="invalidload in invaliddeliveredload"
                      >{{ invalidload }}&nbsp;&nbsp;</strong
                    >
                  </h6>

                  <br />

                  <h6>
                    <b>Booking Pending Or Delivered : </b>
                    <!-- <br> -->
                    <strong
                      v-if="rejectedload != ''"
                      style="color:#FF6347;"
                      v-for="rejload in rejectedload"
                      >{{ rejload }} &nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6 >
                    <b>Particular Load Date Format is Invalid : </b>

                    <strong v-if="incompletedataload != ''"
                      style="color:#FF6347;"
                      v-for="incompletedataload in incompletedataload"
                      >{{ incompletedataload }} &nbsp;&nbsp;
                    </strong>
                  </h6>
                  <br>
                  <h6>
                    <b>Rejected Due to Dispatch Date : </b>

                    <strong  v-if="rejectedduetodispatchdate != ''"
                      style="color:#FF6347;"
                      v-for="rejectedduetodispatchdate in rejectedduetodispatchdate"
                      >{{ rejectedduetodispatchdate }} &nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br>

                  <h6 v-if="incompletedataload != ''">
                    <b>Valid Date Format is: </b>

                    <strong style="color:#FF6347;"
                      >YYYY - MM - DD &nbsp;&nbsp;
                    </strong>
                  </h6>

                </span>
              </b-col>

              <b-col
                md="12"
                v-if="selectedAction == 'RTO' || selectedAction == 'Lost'"
              >
                <span>
                  <h6>
                    <b>Accepted Load : </b>

                    <strong
                      v-if="accceptedload != ''"
                      v-for="rtoacceptedload in accceptedload"
                      >{{ rtoacceptedload }}&nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6>
                    <b>Invalid Load in CSV : </b>

                    <strong
                      v-if="invalidload != ''"
                      style="color:#FF6347;"
                      v-for="invalidload in invalidload"
                      >{{ invalidload }}&nbsp;&nbsp;</strong
                    >
                  </h6>

                  <br />

                  <h6 v-if="selectedAction == 'RTO'">
                    <b>Already RTO Load in CSV : </b>

                    <strong
                      v-if="alreadyRTOload != ''"
                      style="color:#FF6347;"
                      v-for="alreadyRTOload in alreadyRTOload"
                      >{{ alreadyRTOload }} &nbsp;&nbsp;
                    </strong>
                  </h6>
                  <h6 v-if="selectedAction == 'Lost'">
                    <b>Already Lost Load in CSV : </b>

                    <strong
                      v-if="alreadyRTOload != ''"
                      style="color:#FF6347;"
                      v-for="alreadyRTOload in alreadyRTOload"
                      >{{ alreadyRTOload }} &nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6>
                    <b>Rejected Load in CSV : </b>

                    <strong
                      v-if="rejectedload != ''"
                      style="color:#FF6347;"
                      v-for="rejectedload in rejectedload"
                      >{{ rejectedload }} &nbsp;&nbsp;
                    </strong>
                  </h6>
                </span>
              </b-col>

              <b-col
                md="12"
                v-if="selectedAction == 'ZoneOutScan' || selectedAction == 'DispatchOutScan' || selectedAction == 'OFD' || selectedAction == 'PickDone'"
              >
                <span>
                  <h6>
                    <b>Accepted Loads : </b>

                    <strong
                      v-if="accceptedload != ''"
                      v-for="rtoacceptedload in accceptedload"
                      >{{ rtoacceptedload }}&nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6>
                    <b>Invalid Loads : </b>

                    <strong
                      v-if="invalidload != ''"
                      style="color:#FF6347;"
                      v-for="invalidload in invalidload"
                      >{{ invalidload }}&nbsp;&nbsp;</strong
                    >
                  </h6>

                  <br />

                  <h6 >
                    <b>Already Updated Loads: </b>

                    <strong
                      v-if="alreadyRTOload != ''"
                      style="color:#FF6347;"
                      v-for="alreadyRTOload in alreadyRTOload"
                      >{{ alreadyRTOload }} &nbsp;&nbsp;
                    </strong>
                  </h6>
          
                  <br />

                  <h6>
                    <b>Rejected Loads : </b>

                    <strong
                      v-if="rejectedload != ''"
                      style="color:#FF6347;"
                      v-for="rejectedload in rejectedload"
                      >{{ rejectedload }} &nbsp;&nbsp;
                    </strong>
                  </h6>
                </span>
              </b-col>
              <b-col md="12" v-if="selectedAction == 'partialDLV'">
                <span>

                  <h6>
                    <b> Partial Delivered Load : </b>

                    <!-- <br> -->
                    <strong
                      v-if="partial_deliveredload != ''"
                      v-for="divload in partial_deliveredload"
                      >{{ divload }}&nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6>
                    <b>Invalid Load in CSV : </b>
                    <!-- <br> -->
                    <strong
                      v-if="partial_invaliddeliveredload != ''"
                      style="color:#FF6347;"
                      v-for="invalidload in partial_invaliddeliveredload"
                      >{{ invalidload }}&nbsp;&nbsp;</strong
                    >
                  </h6>

                  <br />

                  <h6>
                    <b>Booking Pending Or Partial Delivered : </b>
                    <!-- <br> -->
                    <strong
                      v-if="partial_rejectedload != ''"
                      style="color:#FF6347;"
                      v-for="rejload in partial_rejectedload"
                      >{{ rejload }} &nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6 v-if="partial_incompletedataload != ''">
                    <b>Particular Load Date Format is Invalid : </b>

                    <strong
                      style="color:#FF6347;"
                      v-for="partial_incompletedataload in partial_incompletedataload"
                      >{{ partial_incompletedataload }} &nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br />

                  <h6 v-if="partial_rejectedduetodispatchdate != ''">
                    <b>Rejected Due to Dispatch Date : </b>

                    <strong
                      style="color:#FF6347;"
                      v-for="partial_rejectedduetodispatchdate in partial_rejectedduetodispatchdate"
                      >{{ partial_rejectedduetodispatchdate }} &nbsp;&nbsp;
                    </strong>
                  </h6>

                  <br>
                  <h6 v-if="partial_incompletedataload != ''">
                    <b>Valid Date Format is: </b>

                    <strong style="color:#FF6347;"
                      >DD-MM-YYYY &nbsp;&nbsp;
                    </strong>
                  </h6>
                </span>
              </b-col>
            </b-row>
          </div>

          <b-col sm="12" class="text-right">
            <p>
              <b
                >Total Records :<span style="color:red;">
                  {{ totalRows }}</span
                ></b
              >
            </p>
          </b-col>

          <b-col sm="12">
            <b-table
              show-empty
              stacked="md"
              :busy="isBusy"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
              :bordered="bordered"
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="actions" slot-scope="row">
                <!-- <a :href="csvdownlaod + row.item.file_name" target="_blank" -->
                  <a :href="row.item.url" target="_blank"
                  ><i
                    class="fa fa-download"
                    aria-hidden="true"
                    v-b-tooltip.hover
                    title="Click to download"
                    style="font-size:20px;"
                  ></i
                ></a>
              </template>
              <template v-if="row.item.error_file_url" slot="error_file_url" slot-scope="row">
                  <a :href="row.item.error_file_url" target="_blank"
                  ><i
                    class="fa fa-download"
                    aria-hidden="true"
                    v-b-tooltip.hover
                    title="Click to download"
                    style="font-size:20px;"
                  ></i
                ></a>
              </template>
            </b-table>
          </b-col>

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <paginate
              :page-count="noofpages"
              :page-range="10"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
            >
            </paginate>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
import VueBarcode from "vue-barcode";
export default {
  name: "zonemaster",
  data: function() {
    return {
      name: "zonemaster",
      isBusy: false,
      fields: [
        {
          key: "file_name",
          label: "File Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "createdby",
          label: "Uploaded By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "createddate",
          label: "Uploaded Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "lastmodifieddate",
          label: "Last Modified Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
        },
        // { key: 'pallet_title', label: 'Pallet Title', sortable: true,tdClass: 'nameOfTheClass'},
        // { key: 'transport_mode', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },

        {
          key: "actions",
          label: "Download CSV",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "error_file_url",
          label: "Failure Details",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      myToggle: false,

      bordered: true,
      totalRows: 0,

      currentPage: 1,

      perPage: 20,
      pageOptions: [5, 10, 15],
      sortBy: null,
      options: [],
      pageNum: 1,
      noofpages: "",
      sortDesc: false,
      allowCustomValue: true,
      sortDirection: "desc",
      filter: null,
      customer: {},
      selectcsvFile: "",
      file: "",
      selectFiletype: "",
      acceptedloads: [],
      invalidload: [],
      invalidvehicleno: [],
      otherstatusload: [],
      deliveredload: [],
      invaliddeliveredload: [],
      rejectedload: [],
      bookingDateGreaterthanDeliveryDate: [],

      incompletedataload: [],
      resultMsg: "",
      csvdownlaod: "",
      selectedAction: "",
      selected: "",
      sampleBookingDoneLink: "",
      accceptedload: [],
      invalidload: [],
      alreadyRTOload: [],
      rejectedload: [],
      rejectedduetodispatchdate:[],
      selectedStatus :'',
      selectedReason :'',
      reasonList :[],


      ///

      partial_deliveredload :[],
      partial_invaliddeliveredload :[],
      partial_rejectedload : [],
      partial_incompletedataload : [],
      partial_rejectedduetodispatchdate : [],
      accessBody:[],
      isReadOnly:false,
      addzone:false,
    };
  },
  components: {
    barcode: VueBarcode,
  },
  created: function() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    // const url = `http://65.2.154.47/api_ftl/downloadcsv?key=`;
    const url = `${CONSTANTS.MIGRATION_API_URL}/downloadcsv?key=`;
    this.csvdownlaod = url;
    this.fileName = "getadhocs3datasampleBD.csv";
    // const sampleURL = `http://65.2.154.47/api_ftl/downloadcsv?key=`;
    const sampleURL = `${CONSTANTS.MIGRATION_API_URL}/downloadcsv?key=`
    this.sampleBookingDoneLink = sampleURL;
    this.accessBody = userInfo.body;

      this.ischeckbodyvalidation();
    this.getrtoreasonlist();
    this.uploadcsvfilelisting(this.pageNum);
  },
  // beforeDestroy() { this.$validator.pause() },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  methods: {
    ischeckbodyvalidation(){
      for (let i = 0; i < this.accessBody.length; i++) {
        const element = this.accessBody[i];
     
        // if (element.title=='Adhoc Allocation' && element.isReadonly==true && this.route_id=='normal') {
        //   this.isReadOnly=true
        // }
       if (element.child) {
        for (let j = 0; j < element.child.length; j++) {
          const k = element.child[j];
           if (k.title=='Adhoc Allocation' && k.isReadonly==true) {
            this.isReadOnly=true
          }
          if (k.title=='Bulk Status Update' && k.isReadonly==true) {
            this.isReadOnly=true
          }

        }
       }
      }
      console.log(" this.isReadOnly", this.isReadOnly)
    },
    clickCallback(pageNum) {
      this.addzone=false;
      this.uploadcsvfilelisting(pageNum);
    },
    uploadcsvfilelisting: function(pagee) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      this.isBusy = true;

      var csvObj = {
        page_no: pagee,
      };

      console.log("csvObj", csvObj);
      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/uploadcsvfileListing`, csvObj)
        .then((result) => {
          console.log("Result", result);
          this.isBusy = false;

          if (result.body.returnmsg === "Successful") {
            this.items = result.body.returnvalue;
            this.totalRows = result.body.totalrecords;

            this.noofpages = parseInt(this.totalRows) / 20;

            this.noofpages = Math.ceil(this.noofpages);
          } else {
            this.showdata = [];
            this.items = [];
            this.totalRows = 0;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.uploadcsvFile();
        }
      });
    },

    uploadcsv: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // this.$validator.reset();

      // console.log(this.myToggle)
      if (this.myToggle == true) {
        this.errors.clear("form-1");
        // this.$validator.reset("form-1");
        // var addzone = document.getElementById("addzone");
        // addzone.style.display = "block";
        this.addzone=true;
        var showerror = document.getElementById("showerror");
        showerror.style.display = "none";
        this.selectedAction = "";
        this.file = "";
        this.selectedStatus ='';
        this.selectedReason ='';
        
      } else {
        this.errors.clear("form-1");
        // var addzone = document.getElementById("addzone");
        // addzone.style.display = "none";
        this.addzone=false;
        var showerror = document.getElementById("showerror");
        showerror.style.display = "none";
        this.selectedAction = "";
        this.file = "";
        this.selectedStatus ='';
        this.selectedReason ='';
      }
    },

    selectcsvFiletoUpload(event) {
      this.selectcsvFile = event.target.files[0];
      // this.imgname= this.selectedFiles.name;
  
      console.log("HHH", this.selectcsvFile);

      this.selectFiletype = event.target.files[0].type;
      console.log("selectFiletype", this.selectFiletype);
    },

    uploadcsvFile: function() {
      console.log("csvFile222222222",csvFile,this.selectcsvFile)
      let csvFile=this.selectcsvFile
      console.log("csvFile",csvFile,this.selectcsvFile)
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      if (this.selectedAction == "BookingDone") {
        if (this.selectFiletype == "text/csv") {
          let data = new FormData();
          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);
          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/uploadadhocs3file`, data, {
              header: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                // alert("inn");
                this.$fire({
                  // text: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Accepted Load:</b> ${result.body.acceptedloads ? result.body.acceptedloads: '-'}<br/>
                            <b>Other Status Load:</b> ${result.body.otherstatusload ? result.body.otherstatusload : '-'}<br/>
                            <b>Invalid Vehicle No:</b> ${result.body.invalidvehicleno ? result.body.invalidvehicleno : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span>
                          `,
                  type: "success",
                  timer: 30000,
                });
                this.uploadcsvfilelisting(this.pageNum);

                this.acceptedloads =
                  this.acceptedloads != "" ||
                  (this.acceptedloads != null &&
                    this.acceptedloads != undefined)
                    ? result.body.acceptedloads.split(",")
                    : "";
                // console.log("this.acceptedloads",this.acceptedloads);
                this.invalidload =
                  this.invalidload != "" ||
                  (this.invalidload != null && this.invalidload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";
                this.invalidvehicleno =
                  this.invalidvehicleno != "" ||
                  (this.invalidvehicleno != null &&
                    this.invalidvehicleno != undefined)
                    ? result.body.invalidvehicleno.split(",")
                    : "";
                this.otherstatusload =
                  this.otherstatusload != "" ||
                  (this.otherstatusload != null &&
                    this.otherstatusload != undefined)
                    ? result.body.otherstatusload.split(",")
                    : "";

                // console.log("this.otherstatusload",this.otherstatusload);
                // this.errors.clear("form-1");
                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                csvFile = '';
                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      } else if (this.selectedAction == "Delivered") {
        if (this.selectFiletype == "text/csv") {
          let data = new FormData();

          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);

          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config111111111111111", config);
          // return false;
          this.$http
            .post(
              `${CONSTANTS.MIGRATION_API_URL}/updateCsvtoDeliverstatus`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((result) => {
              console.log("YYY11111111111111111111111111111", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                this.$fire({
                  // text: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Delivered Load:</b> ${result.body.deliveredload ? result.body.deliveredload: '-'}<br/>
                            <b>Rejected Load:</b> <span style="color:red;">${result.body.rejectedload ? result.body.rejectedload : '-'}</span><br/>
                            <b>Incomplete Data Load:</b> ${result.body.incompletedataload ? result.body.incompletedataload : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span><br/>
                            <b>Rejected due to dispatch date:</b> ${result.body.rejectedduetodispatchdate ? result.body.rejectedduetodispatchdate : '-'}<br/>
                            
                          `,
                  type: "success",
                  timer: 30000,
                });
                this.uploadcsvfilelisting(this.pageNum);
                this.deliveredload =
                  this.deliveredload != "" ||
                  (this.deliveredload != null &&
                    this.deliveredload != undefined)
                    ? result.body.deliveredload.split(",")
                    : "";
                this.invaliddeliveredload =
                  this.invaliddeliveredload != "" ||
                  (this.invaliddeliveredload != null &&
                    this.invaliddeliveredload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";
                this.rejectedload =
                  this.rejectedload != "" ||
                  (this.rejectedload != null && this.rejectedload != undefined)
                    ? result.body.rejectedload.split(",")
                    : "";
                this.incompletedataload =
                  this.incompletedataload != "" ||
                  (this.incompletedataload != null &&
                    this.incompletedataload != undefined)
                    ? result.body.incompletedataload.split(",")
                    : "";
                    this.rejectedduetodispatchdate =
                  this.rejectedduetodispatchdate != "" ||
                  (this.rejectedduetodispatchdate != null &&
                    this.rejectedduetodispatchdate != undefined)
                    ? result.body.rejectedduetodispatchdate.split(",")
                    : "";
                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                csvFile = '';
                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
              }
            }).catch((ex) => {
              console.log("error", ex);
              document.getElementById("overlay").style.display = "none";
              console.log("111111111111111111111111111111111111",csvFile)
              csvFile = '';
              console.log("1222222222222222222222222222",csvFile)
              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      } else if (this.selectedAction == "RTO") {
        if (this.selectFiletype == "text/csv") {
          // alert("inn");
          let data = new FormData();

          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);
          data.append("status", this.selectedStatus);
          data.append("rto_statuscode", this.selectedReason);

          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(
              `${CONSTANTS.MIGRATION_API_URL}/updateLoadstatustoRTO`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                this.$fire({
                  // title: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Accepted Load:</b> ${result.body.accceptedload ? result.body.accceptedload: '-'}<br/>
                            <b>Rejected Load:</b> <span style="color:red;">${result.body.rejectedload ? result.body.rejectedload : '-'}</span><br/>
                            <b>Already RTO Load:</b> ${result.body.alreadyRTOload ? result.body.alreadyRTOload : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span>
                          `,
                  type: "success",
                  timer: 30000,
                });
                
                this.uploadcsvfilelisting(this.pageNum);
                console.log("JHJGJHG", result.body.returnvalue);

                this.accceptedload =
                  this.accceptedload != "" ||
                  (this.accceptedload != null &&
                    this.accceptedload != undefined)
                    ? result.body.accceptedload.split(",")
                    : "";

                this.invalidload =
                  this.invalidload != "" ||
                  (this.invalidload != null && this.invalidload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";

                this.alreadyRTOload =
                  this.alreadyRTOload != "" ||
                  (this.alreadyRTOload != null &&
                    this.alreadyRTOload != undefined)
                    ? result.body.alreadyRTOload.split(",")
                    : "";

                this.rejectedload =
                  this.rejectedload != "" ||
                  (this.rejectedload != null && this.rejectedload != undefined)
                    ? result.body.rejectedload.split(",")
                    : "";

                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      } else if (this.selectedAction == "Lost") {
        if (this.selectFiletype == "text/csv") {
          // alert("inn");
          let data = new FormData();

          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);

          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(
              `${CONSTANTS.MIGRATION_API_URL}/updateLoadstatustoLOST`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                this.$fire({
                  // text: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Accepted Load:</b> ${result.body.accceptedload ? result.body.accceptedload: '-'}<br/>
                            <b>Rejected Load:</b> <span style="color:red;">${result.body.rejectedload ? result.body.rejectedload : '-'}</span><br/>
                            <b>Already Lost Load:</b> ${result.body.alreadyLostload ? result.body.alreadyLostload : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span>
                          `,
                  type: "success",
                  timer: 30000,
                });
                this.uploadcsvfilelisting(this.pageNum);
                console.log("JHJGJHG", result.body.returnvalue);

                this.accceptedload =
                  this.accceptedload != "" ||
                  (this.accceptedload != null &&
                    this.accceptedload != undefined)
                    ? result.body.accceptedload.split(",")
                    : "";

                this.invalidload =
                  this.invalidload != "" ||
                  (this.invalidload != null && this.invalidload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";

                this.alreadyRTOload =
                  this.alreadyRTOload != "" ||
                  (this.alreadyRTOload != null &&
                    this.alreadyRTOload != undefined)
                    ? result.body.alreadyLostload.split(",")
                    : "";

                this.rejectedload =
                  this.rejectedload != "" ||
                  (this.rejectedload != null && this.rejectedload != undefined)
                    ? result.body.rejectedload.split(",")
                    : "";

                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                csvFile = '';
                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      } else if (['ZoneOutScan','DispatchOutScan','OFD','PickDone'].includes(this.selectedAction)) {
        if (this.selectFiletype == "text/csv") {
          // alert("inn");
          let data = new FormData();

          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);

          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(
              `${CONSTANTS.MIGRATION_API_URL}/updateLoadStatusBasedOnInputAction`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                this.$fire({
                  // text: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Accepted Load:</b> ${result.body.accceptedLoads ? result.body.accceptedLoads: '-'}<br/>
                            <b>Rejected Load:</b> <span style="color:red;">${result.body.rejectedLoads ? result.body.rejectedLoads : '-'}</span><br/>
                            <b>Already Updated Load:</b> ${result.body.alreadyUpdatedLoads ? result.body.alreadyUpdatedLoads : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span>
                          `,
                  type: "success",
                  timer: 30000,
                });
                this.uploadcsvfilelisting(this.pageNum);
                console.log("JHJGJHG", result.body.returnvalue);

                this.accceptedload =
                  this.accceptedload != "" ||
                  (this.accceptedload != null &&
                    this.accceptedload != undefined)
                    ? result.body.accceptedLoads.split(",")
                    : "";

                this.invalidload =
                  this.invalidload != "" ||
                  (this.invalidload != null && this.invalidload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";

                this.alreadyRTOload =
                  this.alreadyRTOload != "" ||
                  (this.alreadyRTOload != null &&
                    this.alreadyRTOload != undefined)
                    ? result.body.alreadyUpdatedLoads.split(",")
                    : "";

                this.rejectedload =
                  this.rejectedload != "" ||
                  (this.rejectedload != null && this.rejectedload != undefined)
                    ? result.body.rejectedLoads.split(",")
                    : "";

                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                csvFile = '';
                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
                this.selectFiletype = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      } else if (this.selectedAction == "partialDLV") {
        if (this.selectFiletype == "text/csv") {
          let data = new FormData();

          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);

          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(
              `${CONSTANTS.MIGRATION_API_URL}/updateCSVToPartialDelivery`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                this.$fire({
                  // text: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Partial Delivered Load:</b> ${result.body.partialdeliveredload ? result.body.partialdeliveredload: '-'}<br/>
                            <b>Rejected Load:</b> <span style="color:red;">${result.body.rejectedload ? result.body.rejectedload : '-'}</span><br/>
                            <b>Incomplete Data Load:</b> ${result.body.incompletedataload ? result.body.incompletedataload : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span>
                            <b>Rejected due to Dispatch Date:</b> ${result.body.rejectedduetodispatchdate ? result.body.rejectedduetodispatchdate : '-'}<br/>
                          `,
                  type: "success",
                  timer: 30000,
                });
                this.uploadcsvfilelisting(this.pageNum);
                this.partial_deliveredload =
                  this.partial_deliveredload != "" ||
                  (this.partial_deliveredload != null &&
                    this.partial_deliveredload != undefined)
                    ? result.body.partialdeliveredload.split(",")
                    : "";
                this.partial_invaliddeliveredload =
                  this.partial_invaliddeliveredload != "" ||
                  (this.partial_invaliddeliveredload != null &&
                    this.partial_invaliddeliveredload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";
                this.partial_rejectedload =
                  this.partial_rejectedload != "" ||
                  (this.partial_rejectedload != null && this.partial_rejectedload != undefined)
                    ? result.body.rejectedload.split(",")
                    : "";
                this.partial_incompletedataload =
                  this.partial_incompletedataload != "" ||
                  (this.partial_incompletedataload != null &&
                    this.partial_incompletedataload != undefined)
                    ? result.body.incompletedataload.split(",")
                    : "";

                    this.partial_rejectedduetodispatchdate =
                  this.partial_rejectedduetodispatchdate != "" ||
                  (this.partial_rejectedduetodispatchdate != null &&
                    this.partial_rejectedduetodispatchdate != undefined)
                    ? result.body.rejectedduetodispatchdate.split(",")
                    : "";

                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      } else if (this.selectedAction == "RTO-DLV") {
        if (this.selectFiletype == "text/csv") {
          // alert("inn");
          let data = new FormData();

          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);
          //data.append("status", this.selectedStatus);
         // data.append("rto_statuscode", this.selectedReason);

          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(
              `${CONSTANTS.MIGRATION_API_URL}/updateLoadstatustoRTODLV`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                this.$fire({
                  // title: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Accepted Load:</b> ${result.body.accceptedload ? result.body.accceptedload: '-'}<br/>
                            <b>Rejected Load:</b> <span style="color:red;">${result.body.rejectedload ? result.body.rejectedload : '-'}</span><br/>
                            <b>Already RTO Load:</b> ${result.body.alreadyRTOload ? result.body.alreadyRTOload : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span>
                          `,
                  type: "success",
                  timer: 30000,
                });
                
                this.uploadcsvfilelisting(this.pageNum);
                console.log("JHJGJHG", result.body.returnvalue);

                this.accceptedload =
                  this.accceptedload != "" ||
                  (this.accceptedload != null &&
                    this.accceptedload != undefined)
                    ? result.body.accceptedload.split(",")
                    : "";

                this.invalidload =
                  this.invalidload != "" ||
                  (this.invalidload != null && this.invalidload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";

                this.alreadyRTOload =
                  this.alreadyRTOload != "" ||
                  (this.alreadyRTOload != null &&
                    this.alreadyRTOload != undefined)
                    ? result.body.alreadyRTOload.split(",")
                    : "";

                this.rejectedload =
                  this.rejectedload != "" ||
                  (this.rejectedload != null && this.rejectedload != undefined)
                    ? result.body.rejectedload.split(",")
                    : "";

                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      }else if (['RTOHubInScan','RTOZoneInScan','RTOZoneOutScan','RTODispatchOutScan','RTOINTransit','RTOOFD','RTOpartialDLV','RTOLost'].includes(this.selectedAction)){
        if (this.selectFiletype == "text/csv") {
          // alert("inn");
          let data = new FormData();

          // data.append("file", this.selectcsvFile);
          data.append("file", csvFile);
          data.append(
            "createdby",
            userInfo.userfirstname + " " + userInfo.userlastname
          );
          data.append("action", this.selectedAction);

          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(
              `${CONSTANTS.MIGRATION_API_URL}/updateLoadstatustoRTOAll`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                this.$fire({
                  // text: result.body.returnvalue,
                  html: `
                            ${result.body.returnvalue}<br/>
                            <b>Accepted Load:</b> ${result.body.accceptedload ? result.body.accceptedload: '-'}<br/>
                            <b>Rejected Load:</b> <span style="color:red;">${result.body.rejectedload ? result.body.rejectedload : '-'}</span><br/>
                            <b>Already Lost Load:</b> ${result.body.alreadyLostload ? result.body.alreadyLostload : '-'}<br/>
                            <b>Invalid Load:</b> <span style="color:red;">${result.body.invalidload ? result.body.invalidload : '-'}</span>
                          `,
                  type: "success",
                  timer: 30000,
                });
                this.uploadcsvfilelisting(this.pageNum);
                console.log("JHJGJHG", result.body.returnvalue);

                this.accceptedload =
                  this.accceptedload != "" ||
                  (this.accceptedload != null &&
                    this.accceptedload != undefined)
                    ? result.body.accceptedload.split(",")
                    : "";

                this.invalidload =
                  this.invalidload != "" ||
                  (this.invalidload != null && this.invalidload != undefined)
                    ? result.body.invalidload.split(",")
                    : "";

                this.alreadyRTOload =
                  this.alreadyRTOload != "" ||
                  (this.alreadyRTOload != null &&
                    this.alreadyRTOload != undefined)
                    ? result.body.alreadyLostload.split(",")
                    : "";

                this.rejectedload =
                  this.rejectedload != "" ||
                  (this.rejectedload != null && this.rejectedload != undefined)
                    ? result.body.rejectedload.split(",")
                    : "";

                // var addzone = document.getElementById("addzone");
                // addzone.style.display = "none";
                this.addzone=false;
                this.selectcsvFile = "";
                this.selectFiletype = "";
                csvFile = '';
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                csvFile = '';
                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
              this.selectFiletype = "";
              this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
      }
    },

    refresh: function() {
      this.errors.clear("form-1");
      // var addzone = document.getElementById("addzone");
      // addzone.style.display = "none";
      this.addzone=false;
      this.selectcsvFile = "";
      this.selectFiletype = "";
      this.acceptedloads = [];
      this.invalidload = [];
      this.invalidvehicleno = [];
      this.otherstatusload = [];
      this.deliveredload = [];
      this.invaliddeliveredload = [];
      this.rejectedload = [];
      this.incompletedataload = [];
      this.accceptedload = [];
      this.invalidload = [];
      this.alreadyRTOload = [];
      this.rejectedload = [];
      this.uploadcsvfilelisting(this.pageNum);
      var showerror = document.getElementById("showerror");
      showerror.style.display = "none";
    },

    clear: function() {
      this.zoneno = "";
      this.tags2 = [];
      this.errors.clear("form-1");
    },

    getrtoreasonlist(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const obj={}
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getrtoreasonlist`, obj)
        .then((result) => {
          console.log("Result", result);

          if (result.body.returnmsg === "Successful") {
            this.reasonList = result.body.returnvalue;
          } else {
            this.reasonList = [];
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    }
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.nameOfTheClass {
  max-width: 166px !important;
}
.ti-new-tag-input-wrapper input[data-v-61d92e31] {
  flex: 1 0 auto;
  min-width: 310px;
  border: none;
  padding: 0px;
  margin: 0px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
#overlayyy {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loaderrr {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
.loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
#vendor_list_scroll {
  max-height: 500px;
  overflow-x: scroll;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
</style>
